import { render, staticRenderFns } from "./PaymentStep.vue?vue&type=template&id=6b2fef90"
import script from "./PaymentStep.vue?vue&type=script&lang=js"
export * from "./PaymentStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b2fef90')) {
      api.createRecord('6b2fef90', component.options)
    } else {
      api.reload('6b2fef90', component.options)
    }
    module.hot.accept("./PaymentStep.vue?vue&type=template&id=6b2fef90", function () {
      api.rerender('6b2fef90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/test-award/components/PaymentStep.vue"
export default component.exports